import { render, staticRenderFns } from "./ApplicationLanguageDropdown.vue?vue&type=template&id=4f91bcfb&scoped=true"
import script from "./ApplicationLanguageDropdown.vue?vue&type=script&lang=js"
export * from "./ApplicationLanguageDropdown.vue?vue&type=script&lang=js"
import style0 from "./ApplicationLanguageDropdown.vue?vue&type=style&index=0&id=4f91bcfb&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f91bcfb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2326903440/src/bitbucket.org/Modis-ito/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f91bcfb')) {
      api.createRecord('4f91bcfb', component.options)
    } else {
      api.reload('4f91bcfb', component.options)
    }
    module.hot.accept("./ApplicationLanguageDropdown.vue?vue&type=template&id=4f91bcfb&scoped=true", function () {
      api.rerender('4f91bcfb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/common/components/ApplicationLanguageDropdown.vue"
export default component.exports